import React, {useEffect, useState} from "react";
import Table from "../../../components/Table/Table";
import {useGetAdditives} from "../../../hooks/Administrative/useGetAdditives";
import './AdministrativeAdditives.css'
import {useAddAdditive} from "../../../hooks/Administrative/useAddAdditive";
import {Bounce, toast} from "react-toastify";
import SearchTicketModal from "../../../components/SearchTicketModal/SearchTicketModal";
import {useGetAdditivesByUniqueCode} from "../../../hooks/Administrative/useGetAdditivesByUniqueCode";
import {useUpdateAdditive} from "../../../hooks/Administrative/useUpdateAdditive";

const columns = ["NOMBRE", "CLAVE"];

const AdministrativeAdditives = () => {

    const [filters, setFilters] = useState({});
    const {additives, totalPages, isLoading, page, setPage, addAdditiveLocally, updateAdditiveLocally} = useGetAdditives({filters})
    const [showAddAdditive, setShowAddAdditive] = useState(false);
    const [isConfirmDisabled, setIsConfirmDisabled] = useState(true);
    const [additiveName, setAdditiveName] = useState("");
    const [additiveUniqueCode, setAdditiveUniqueCode] = useState("");
    const {addNewAdditive, saving} = useAddAdditive();
    const [isSearchModalVisible, setSearchModalVisible] = useState(false);
    const [showEditAdditive, setShowEditAdditive] = useState(false);
    const { additive, fetchAdditiveByUniqueCode } = useGetAdditivesByUniqueCode();
    const [editDisabled, setEditDisabled] = useState(true);
    const [localName, setLocalName] = useState("");
    const { updateExistingAdditive, updatingAdditive } = useUpdateAdditive();

    useEffect(() => {
        if(additive){
            setLocalName(additive.name);
        }
    }, [additive]);

    useEffect(() => {
        const isDisabled = !additiveName || !additiveUniqueCode
        setIsConfirmDisabled(isDisabled);
    }, [additiveName, additiveUniqueCode]);

    const handleAddAdditive = () => {
        setShowEditAdditive(false);
        setShowAddAdditive(true);
    }

    const clearFields = () => {
        setAdditiveUniqueCode("")
        setAdditiveName("")
    }

    const handleSearchModal = (uniqueCode: string) => {
        setFilters({uniqueCode});
    };

    const handleResetClientsTable = () => {
        setFilters({});
        setPage(0);
    };

    const handleOnRowClick = (row: Record<string, any>) => {
        setShowAddAdditive(false);
        setShowEditAdditive(true);
        fetchAdditiveByUniqueCode(row.ID);
    };

    const validateField = (field: any, regex: any, errorMessage: any) => {
        if (!regex.test(field)) {
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
            return false;
        }
        return true;
    };

    const handleUpdate = () => {
        if (!validateField(localName, /^.{1,60}$/, "El nombre del aditivo no puede exceder los 60 caracteres ni estar vacío.")) return;
        const updatedAdditive = {
            name: localName,
            uniqueCode: additive.uniqueCode
        }

        updateExistingAdditive(updatedAdditive, additive.id).then(response => {
            toast.success('¡Aditivo actualizado correctamente!', {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });

            updateAdditiveLocally(additive.uniqueCode, localName)
            setShowEditAdditive(false);
            setEditDisabled(true);

        }).catch(error => {
            toast.error("Error al actualizar aditivo", {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
        })

    }

    const handleNewAdditive = (e: React.FormEvent) => {
        e.preventDefault();

        if (!validateField(additiveName, /^.{1,60}$/, "El nombre del aditivo no puede exceder los 60 caracteres ni estar vacío.")) return;
        if (!validateField(additiveUniqueCode, /^[a-zA-Z0-9_]{5,50}$/, "El código único solo puede contener letras, " +
            "números y guión bajo (_). Tiene que tener entre 5 y 10 caracteres.")) return;

        const newAdditive = {
            name: additiveName,
            uniqueCode: additiveUniqueCode
        }
        addNewAdditive(newAdditive).then((response: any) => {
                toast.success('¡Aditivo creado correctamente!', {
                    position: 'top-right',
                    autoClose: 4000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false,
                    theme: 'colored',
                    transition: Bounce,
                });
                addAdditiveLocally(response);
                clearFields()
            }
        ).catch((err: any) => {
            toast.error(err, {
                position: 'top-right',
                autoClose: 4000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                theme: 'colored',
                transition: Bounce,
            });
        })
    }

    return (
        <div className="additive-view-container">
            <div className="additive-view-left">
                <div className="additive-view-header">
                    <div className="additive-view-header-title">
                        <p>ADITIVOS</p>
                    </div>
                    <span className="material-icons-outlined icon-unselected" onClick={handleAddAdditive}>
                        add_box
                </span>
                    <span className="material-icons-outlined icon-unselected" onClick={() => {
                        setSearchModalVisible(true)
                    }}>
                    search
                </span>
                    <span className="material-icons-outlined icon-unselected" onClick={handleResetClientsTable}>
                    restart_alt
                </span>
                </div>
                {isLoading ?
                    (
                        <div className="loading-overlay">
                            <div className="spinner"></div>
                            <div className="loading-message">Obteniendo información...</div>
                        </div>
                    ) : (
                        <div className="additive-table-container">
                            <Table
                                columns={columns}
                                data={additives}
                                totalPages={totalPages}
                                currentPage={page}
                                setCurrentPage={setPage}
                                onRowClick={handleOnRowClick}
                            />
                        </div>
                    )}
            </div>
            <div className="add-additive">
                {showAddAdditive && (
                    <div className="additive-actions-container">
                        <div className="additives-view-actions-wrapper">
                            {saving ?
                                (
                                    <div className="loading-overlay-for-additive-view">
                                        <div className="spinner"></div>
                                        <div className="loading-message">Guardando</div>
                                    </div>
                                ) :
                                (
                                    <div>
                                        <div className="additive-view-header">
                                            <div className="additive-view-header-title">
                                                <p>AÑADIR ADITIVO</p>
                                            </div>
                                        </div>
                                        <form className="add-additive-form" onSubmit={handleNewAdditive}>
                                            <div className="form-item">
                                                <label htmlFor="name">NOMBRE *</label>
                                                <input
                                                    id="name"
                                                    value={additiveName}
                                                    onChange={(e) => setAdditiveName(e.target.value)}
                                                />
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="name">CÓDIGO ÚNICO *</label>
                                                <input
                                                    id="name"
                                                    value={additiveUniqueCode}
                                                    onChange={(e) => setAdditiveUniqueCode(e.target.value)}
                                                />
                                            </div>
                                            <div className="bottom">
                                                <p>* Campos obligatorios</p>
                                                <div className="buttons">
                                                    <button type="button" className="cancel" onClick={clearFields}>
                                                        Cancelar
                                                    </button>
                                                    <button
                                                        type="submit"
                                                        className={`confirm ${isConfirmDisabled ? 'disabled' : ''}`}
                                                        disabled={isConfirmDisabled}
                                                    >
                                                        Guardar
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                )}

                {updatingAdditive ? (
                    <div className="loading-overlay-for-additive-view">
                        <div className="spinner"></div>
                        <div className="loading-message">Guardando</div>
                    </div>) : (
                    <div>
                        {showEditAdditive && (
                            <div>
                                <div className="plants-info-view-header">
                                    <div className="plants-info-view-header-title">
                                        <p>PLANTA</p>
                                    </div>
                                    <span
                                        className={`material-icons-outlined icon-unselected ${
                                            !editDisabled ? "active-edit" : ""
                                        }`}
                                        onClick={() => setEditDisabled(!editDisabled)}
                                    >
                                edit
                            </span>
                                </div>
                                <div className="plants-info-fields">
                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">CLAVE ÚNICA</div>
                                        <div className="value-label">{additive?.uniqueCode}</div>
                                    </div>
                                    <div className="client-info-attribute">
                                        <div className="client-attribute-label">NOMBRE</div>
                                        <input
                                            className={`value-label ${editDisabled ? "input-disabled" : ""}`}
                                            type="text"
                                            value={localName}
                                            disabled={editDisabled}
                                            onChange={(e) => setLocalName(e.target.value)}
                                        />
                                    </div>
                                    {!editDisabled && (
                                        <div className="bottom-buttons">
                                            <button type="submit" className="confirm" onClick={handleUpdate}>
                                                Guardar
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                )}


                <SearchTicketModal
                    isVisible={isSearchModalVisible}
                    onClose={() => setSearchModalVisible(false)}
                    onSearch={handleSearchModal}
                    placeholder="Clave de aditivo"
                />
            </div>
        </div>
    )
}

export default AdministrativeAdditives;